import type { ComponentType, MouseEvent, ReactNode } from "react";

import type { IconName } from "@similarweb/icons";
import { DotsLoader } from "@similarweb/ui-components";

import { StyledContainer, StyledItemWithSeparator, StyledLoaderWrapper } from "./styles";

type ChipItemType = {
    text: string;
    id?: string | number;
    code?: string;
    iconName?: IconName;
    onCloseItem?(e: MouseEvent<HTMLSpanElement>): void;
};

type ChipItemsContainerProps = {
    items: readonly ChipItemType[];
    className?: string;
    ChipComponent: ComponentType<ChipItemType>;
    renderSeparator?(index: number): ReactNode;
    isLoading?: boolean;
};

const ChipItemsContainer = (props: ChipItemsContainerProps) => {
    const { items, ChipComponent, className, renderSeparator, isLoading } = props;

    const renderItemWithSeparator = (item: ChipItemType, index: number, array: ChipItemType[]) => {
        if (typeof renderSeparator !== "function" || index === array.length - 1) {
            return (
                <ChipComponent
                    key={item.id}
                    {...item}
                />
            );
        }

        return (
            <StyledItemWithSeparator
                key={item.id}
                data-automation="chip-item-with-separator-wrap"
            >
                <ChipComponent {...item} />
                {renderSeparator(index)}
            </StyledItemWithSeparator>
        );
    };

    return (
        <StyledContainer
            className={className}
            data-automation="chip-items-container"
        >
            {items.map(renderItemWithSeparator)}
            {isLoading ? (
                <StyledItemWithSeparator data-automation="loader-wrapper">
                    <StyledLoaderWrapper>
                        <DotsLoader />
                    </StyledLoaderWrapper>
                </StyledItemWithSeparator>
            ) : null}
        </StyledContainer>
    );
};

export default ChipItemsContainer;
